import { useEffect, useState, useCallback } from "react";
import { Alert, Badge, Portal, Snackbar, Tooltip } from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import ProgressCirc from "../../layout/Progress/ProgressCirc";
import { useUserData } from "src/context/userContext";
import { useKeikkaData } from "src/context/KeikkaDataContext";

const styles = {
  div1: { transition: "all 0.7s ease-in-out", opacity: 0.7, cursor: "pointer" },
};

export default function KeikkaConnectedIcon() {
  const { keikkaData } = useKeikkaData();

  const keikkaId = keikkaData?.keikkaId;

  const { socket } = useUserData();
  const [usersCount, setUsersCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarIsOpen, setSnackbarIsOpen] = useState(false);

  const connectListener = useCallback((connCount, _keikkaId) => {
    if (_keikkaId === keikkaId) {
      setUsersCount(connCount);
      setTimeout(() => {
        setIsLoading(false);
      }, 750);
    }
  });

  useEffect(() => {
    if (!socket) return;
    if (!keikkaData) return;
    socket.on("keikkaconncount", connectListener);

    setTimeout(() => {
      // wait for connections to be established before sending the first count request
      // will receive the count from the server into the connectListener
      socket.emit("keikkaconncount", keikkaId);
    }, 1500); // 1.5 seconds
    return () => {
      socket && socket.off("keikkaconncount", connectListener);
    };
  }, [keikkaId, socket]);

  const badgeIcon =
    usersCount === 1 ? (
      <PersonIcon color="primary" className="tabIcon" sx={styles.div1} />
    ) : (
      <GroupIcon color="primary" className="tabIcon" sx={styles.div1} />
    );
  const badgeContent = usersCount === 1 ? 0 : usersCount;

  const handleClick = () => {
    setIsLoading(true);
    const aika = new Date().getTime();
    socket.emit("keikkaconncount", keikkaId);
    socket.on("keikkaconncount", () => {
      const now = new Date().getTime();
      setSnackbarMessage("Ping:" + (now - aika) + "ms");
      setSnackbarIsOpen(true);
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarIsOpen(false);
  };

  return (
    <>
      <Portal>
        <Snackbar
          open={snackbarIsOpen}
          autoHideDuration={2000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleSnackbarClose} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
      {isLoading ? (
        <ProgressCirc />
      ) : (
        <Tooltip title="Ping" placement="top" arrow disableInteractive>
          <Badge badgeContent={badgeContent} className="noPrint">
            <div onClick={handleClick}>{badgeIcon}</div>
          </Badge>
        </Tooltip>
      )}
    </>
  );
}
